'use client';

import { Drawer, DrawerBody, Flex, freddyTheme, IconButton } from '@coolblue-development/freddy';
import { Menu } from '@coolblue-development/icons';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';
import React, { ReactNode, useState } from 'react';

export const HamburgerMenu = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('header.hamburgerMenu');
  const drawerTranslations = useFreddyTranslations('drawer');

  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);

  return (
    <>
      <IconButton
        iconColor='inverse'
        type='button'
        aria-label={showHamburgerMenu ? t('ariaLabel.close') : t('ariaLabel.open')}
        onClick={event => {
          event.preventDefault();
          setShowHamburgerMenu(true);
        }}
        sx={{
          '> svg': {
            width: '2.4rem',
            height: '2.4rem'
          }
        }}
      >
        <Menu size={24} />
      </IconButton>

      <Drawer
        open={showHamburgerMenu}
        onClose={() => setShowHamburgerMenu(false)}
        placement='left'
        title={t('title')}
        body={
          <DrawerBody>
            <Flex
              component='nav'
              direction='column'
              gap={freddyTheme.spacing[300]}
              onClick={() => setShowHamburgerMenu(false)}
              sx={{
                '> svg': {
                  width: '2.4rem',
                  height: '2.4rem'
                }
              }}
            >
              {children}
            </Flex>
          </DrawerBody>
        }
        translations={drawerTranslations}
      />
    </>
  );
};
